import { Button, Flex, message, Table, Tag, Typography } from "antd";
import React, { useEffect, useState } from "react";
import AxiosService from "../services/APIService";
import dayjs from "dayjs";
import CreateNoteModel from "./CreateNoteModel";
import { LocalStorageService } from "../services/LocalStorage";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const Promocode = () => {
  const apiService = new AxiosService();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [promoList, setPromoList] = useState([]);
  const [copiedKey, setCopiedKey] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const paginationLimit = 10;

  const userData = LocalStorageService.getItem("user");

  useEffect(() => {
    fetchPromocodes(page);
  }, [isModalOpen, page]);

  const copyToClipboard = (text, key) => {
    navigator.clipboard.writeText(text).then(() => {
      message.success("Copied to clipboard!");
    });
    setCopiedKey(key);
    setTimeout(() => {
      setCopiedKey(null);
    }, 2000);
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      width: 150,
    },
    {
      title: "Discount Type",
      dataIndex: "discountType",
      key: "discountType",
      width: 200,
    },
    {
      title: "Discount %",
      dataIndex: "discountAmount",
      key: "discountAmount",
    },
    {
      title: "Promo Use Type",
      dataIndex: "promoUseType",
      key: "promoUseType",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = status === "ACTIVE" ? "green" : "volcano";
        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: "Expires At",
      dataIndex: "expiresAt",
      key: "expiresAt",
    },
    {
      title: "Promocode",
      dataIndex: "promoCode",
      key: "promoCode",
      render: (text, record) => (
        <span
          onClick={() => copyToClipboard(text, record.key)}
          style={{ color: "#1677ff", cursor: "pointer" }}
        >
          {copiedKey === record.key ? "Copied!" : "Copy Link"}
        </span>
      ),
    },
  ];

  const fetchPromocodes = (currentPage) => {
    setLoading(true);
    apiService
      .get(
        `/promocode/affiliated/${userData?._id}?page=${currentPage}&limit=${paginationLimit}`
      )
      .then((res) => {
        if (res.success) {
          const formatted = res.payload.data.map((promo) => ({
            key: promo._id,
            code: promo.code,
            discountType: promo.discountType,
            discountAmount: promo.discountAmount,
            promoUseType: promo.promoUseType,
            status: promo.status,
            promoCode: `${process.env.REACT_APP_BASE_URL}?promoCode=${promo.code}&affiliateCode=${userData?.affiliateCode}`,
            expiresAt: dayjs.utc(promo.expiresAt).format("DD-MM-YYYY"),
          }));
          setPromoList(formatted);
          setTotalCount(res.payload.count || 0);
        } else {
          message.error(res.message || "Failed to fetch promocodes");
        }
      })
      .catch((e) => {
        message.error(e.message || "Something went wrong");
      })
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <Typography.Title level={3} className="page-title">
        Promocodes
      </Typography.Title>
      <Table
        pagination={{
          pageSize: paginationLimit,
          current: page,
          total: totalCount,
          onChange: (p) => setPage(p),
        }}
        loading={loading}
        columns={columns}
        dataSource={promoList}
      />
      <CreateNoteModel
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        setLoading={setLoading}
      />
    </div>
  );
};

export default Promocode;
